import { render, staticRenderFns } from "./AttachmentUploaderList.vue?vue&type=template&id=71e1e471&scoped=true"
import script from "./AttachmentUploaderList.vue?vue&type=script&lang=js"
export * from "./AttachmentUploaderList.vue?vue&type=script&lang=js"
import style0 from "./AttachmentUploaderList.vue?vue&type=style&index=0&id=71e1e471&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e1e471",
  null
  
)

export default component.exports